<template>
  <div class="slide-options-container">
    <div v-for="slide in slides" :key="slide.id" @click="changeTab(slide)" class="slide-options-container__option"
      :class="{ 'active': currentSlide === (slide.id - 1) }">
      <h3 v-html="slide.title" class="title">
      </h3>
    </div>
  </div>
  <div class="slide-content-container">
    <button class="slide-content-container__prev" @click="goToPreviousSlide" v-if="currentSlide !== 0"></button>
    <component :is="slides[currentSlide].component" class="slide-content-container__component" />
    <button class="slide-content-container__next" @click="goToNextSlide"
      v-if="currentSlide !== slides.length - 1"></button>
  </div>
</template>

<script>
import SingleSkuOrderInformation from './slides-one/SingleSkuOrderInformation.vue';
import LitholamFlatbedDieCutter from './slides-one/LitholamFlatbedDieCutter.vue';
import DigilamFlatbedDieCutter from './slides-one/DigilamFlatbedDieCutter.vue';
import DigilamVsLitholamCosts from './slides-one/DigilamVsLitholamCosts.vue';
import DigilamVsLitholamManufacturing from './slides-one/DigilamVsLitholamManufacturing.vue';

export default {
  name: 'ScenarioOne',
  components: {
    SingleSkuOrderInformation,
    LitholamFlatbedDieCutter,
    DigilamFlatbedDieCutter,
    DigilamVsLitholamCosts,
    DigilamVsLitholamManufacturing,
  },
  methods: {
    changeTab(payload) {
      this.currentSlide = payload.id - 1;
    },
    goToPreviousSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide -= 1;
      }
    },
    goToNextSlide() {
      if (this.currentSlide < this.slides.length - 1) {
        this.currentSlide += 1;
      }
    },
  },
  data() {
    return {
      currentSlide: 0,
      slides: [
        {
          id: 1,
          title: 'Single SKU order<br>information',
          component: 'SingleSkuOrderInformation',
        },
        {
          id: 2,
          title: 'LithoLam Flatbed Die Cutter',
          component: 'LitholamFlatbedDieCutter',
        },
        {
          id: 3,
          title: 'HP T700i DigiLam Flatbed Die Cutter',
          component: 'DigilamFlatbedDieCutter',
        },
        {
          id: 4,
          title: 'DigiLam vs<br>LithoLam costs',
          component: 'DigilamVsLitholamCosts',
        },
        {
          id: 5,
          title: 'DigiLam vs LithoLam<br>manufacturing time',
          component: 'DigilamVsLitholamManufacturing',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/views/why-digital/manufacturing-time.scss";
</style>
